import './BenefitsNewServicing.scss';
import { Grid, Typography } from '@mui/material';

const BenefitsNewServicing = ({ data }) => {
  const imageUrls = [
    '/images/benefits/newservicing/item1.png',
    '/images/benefits/newservicing/item2.png'
  ];

  if (!data) {
    return null;
  }

  return (
    <Grid
      container
      sx={{
        '@media (max-width: 900px)': {
          justifyContent: 'center'
        },
        '@media (max-width: 600px)': {
          justifyContent: 'normal'
        }
      }}
    >
      <Grid
        aria-labelledby="benefits-new-servicing-title-id"
        className="benefits-new-servicing"
        item
        xs={12}
        sm={10}
        md={12}
      >
        <Typography
          className="title"
          id="benefits-new-servicing-title-id"
          variant="h2"
          sx={{
            fontSize: '28px',
            fontWeight: '600',
            lineHeight: '34px',
            marginBottom: '50px'
          }}
        >
          {data.title}
        </Typography>
        <Grid
          container
          rowGap={5}
          sx={{
            '@media (max-width: 600px)': {
              height: '100%',
              justifyContent: 'space-between'
            }
          }}
        >
          {data.sections.map((section, index) => (
            <Grid
              key={`section-${section.id}`}
              container
              className="benefits-new-servicing-item"
              spacing={2}
              sx={{
                justifyContent: 'space-between'
              }}
            >
              <Grid item className="img" xs={12} sm={2}>
                <img
                  src={imageUrls[index]}
                  alt=""
                  style={{ width: '90px', height: '80px' }}
                />
              </Grid>
              <Grid item className="content" xs={12} sm={9}>
                <Typography
                  component= "h3"
                  className="item-title"
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    lineHeight: '26px'
                  }}
                >
                  {section.title}
                </Typography>
                {section?.list.map((listItem) => (
                  <div
                    key={`ben1-${listItem.id}`}
                    dangerouslySetInnerHTML={{ __html: listItem.item }}
                  ></div>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BenefitsNewServicing;
